module.exports = __webpack_public_path__ + "img/fundermax-obra-4-1.05c4a40c.jpg";